import { deleteFavourite, saveFavourite } from '@propertypal/shared/src/reducers/favourites';
import { AppDispatch } from '@propertypal/shared/src/reducers/store';
import { getItem } from '@propertypal/shared/src/services/storage.secure';
import { TOKEN_ID } from '@propertypal/shared/src/utils/auth';
import router from 'next/router';

const favouriteProperty =
  (dispatch: AppDispatch, propertyId?: number) =>
  async (favourited: boolean, mPropertyId: number = 0) => {
    const token = await getItem(TOKEN_ID);
    const id = propertyId !== undefined ? propertyId : mPropertyId;

    if (!token || !token.loggedIn) {
      const sourcePath = `shortlist?update=${id}&sourcePath=${window.location.pathname}`;
      await router.push(`/login?sourcePath=/${encodeURIComponent(sourcePath)}`);

      return false;
    }

    if (favourited) {
      return dispatch(saveFavourite(id));
    }

    return dispatch(deleteFavourite(id));
  };

export default favouriteProperty;
